import { render } from "./TheLogo.vue?vue&type=template&id=6ab336f3"
import script from "./TheLogo.vue?vue&type=script&lang=js"
export * from "./TheLogo.vue?vue&type=script&lang=js"

import "./TheLogo.vue?vue&type=style&index=0&id=6ab336f3&lang=scss"
script.render = render

export default script